import { render } from "./BaseToast.vue?vue&type=template&id=4d08677c&scoped=true"
import script from "./BaseToast.vue?vue&type=script&lang=js"
export * from "./BaseToast.vue?vue&type=script&lang=js"

import "./BaseToast.vue?vue&type=style&index=0&id=4d08677c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\sciam\\Desktop\\Workspaces\\local\\workspace_vue\\alternativa-takeaway-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d08677c"]])

export default __exports__